<template>
    <footer>
        <div class="footer" style="display: flex; flex-direction: column; justify-content: space-between; padding: 75px 20px 52px 20px; width: 100vw; background: #F1F3F466; padding-top: 75px;">
            <div style="display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 66px;">
                <div v-for="(item, index) in menu" :key="index" style="margin-bottom: 31px">
                    <p style="display: inline-block; font-size: 16px; font-weight: 700; margin-bottom: 11px; margin-right: 168px;">{{item.title}}</p>
                    <div style="display: flex; color: #2C2C2C; font-size: 16px; font-weight: 400">
                        <div v-for="(value, count) in item.sub_title" :key="count" style="display: flex; margin-right: 9px">
                            <span v-if="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1))" style="margin-right: 3px;">이메일:</span>
                            <p @click="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1)) ? copy(value.text) : goPath(value.path)" class="footer_menu">
                                {{value.text}}
                                <span>
                                    <img v-if="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1))" src="@/assets/images/icon/icon-copy.svg" alt="">
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; flex-direction: column;">
                <p style="margin-bottom: 11px; color: #2C2C2C; font-weight: 700; font-size: 15px">(주)필드유</p>
                <div style="display: flex; flex-direction: column; margin-bottom: 40px;">
                    <p class="footer_text_bottom" style="margin-right: 44px;">대표 양지영</p>
                    <!-- <p class="footer_text_bottom" style="margin-right: 44px;">010-4788-8184</p> -->
                    <p class="footer_text_bottom">사업자 등록번호 442-81-01575</p>
                    <p class="footer_text_bottom">경기도 안양시 동안구 시민대로 327번길 11-41,<br>5층 507호</p>
                </div>
                <div style="display: flex; flex-direction: column;">
                    <p @click="goPath('/mobile/pages/privacy-policy')" style="color: #2C2C2C; margin-bottom: 6px; font-size: 15px; font-weight: 700;">채용 개인정보처리방침</p>
                    <p class="footer_text_bottom">Copyright © 2023 FilledU, All rights reserved</p>
                </div>
            </div>
        </div>
        <transition name="fade" appear>
            <div v-if="showSnackBar" style="width: 200px; text-align: center; position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); border-radius: 10px; padding: 10px 12px; background: #000000B3; color: white;">
                메일주소가 복사되었습니다
            </div>
        </transition>
        <!-- <SnackBar v-if="showSnackBar" :info="snackbarInfo" @close="showSnackBar = false" /> -->
    </footer>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar
    },
    data() {
        return {
            menu: [
                {
                    'title': '회사',
                    'sub_title': [
                        {
                            'text': '회사 소개',
                            'path': '/mobile/pages/introduction'
                        },{
                            'text': '제품 소개',
                            'path': '/mobile/pages/production'
                        },
                    ]
                },{
                    'title': '문의',
                    'sub_title': [
                        {
                            'text': '사업 제휴',
                            'path': '/mobile/pages/contact'
                        },{
                            'text': '광고 문의',
                            'path': '/mobile/pages/contact'
                        },{
                            'text': '마케팅･PR',
                            'path': '/mobile/pages/contact'
                        },
                    ]
                },{
                    'title': '고객센터',
                    'sub_title': [
                        {
                            'text': 'mesen@filledyou.com',
                            'path': ''
                        }
                    ]
                }
            ],
            showSnackBar: false,
            snackbarInfo: {
                text: '',
                icon: '',
                color: '',
                background: ''
            },
        }
    },
    methods: {
        copy(val) {
            const textArea = document.createElement("textarea");
            textArea.value = val;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy to clipboard', err);
            }
            document.body.removeChild(textArea);
            this.showSnackBar = true
            setTimeout(() => {
                this.showSnackBar = false
            }, 1500)
        },
        goPath(val) {
            if(this.$route.path == val) {
                this.$router.go()
            } else {
                this.$router.push(val)
            }
        }
    }
    
}
</script>
<style>
    .footer .footer_text_bottom {
        font-size: 15px;
        font-weight: 400;
    }
    .footer .footer_text_bottom_bold {
        font-weight: 400;
    }
    .footer .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .footer .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>